import { NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-energy-interface-list-skeleton',
  templateUrl: './energy-interface-list-skeleton.html',
  imports: [NgTemplateOutlet, Skeleton],
})
export class EnergyInterfaceListSkeleton {}
